import { gql } from "@apollo/client";

export const sendTermsAndConditionsToEmailAdditional = gql(`
    mutation sendTermsAndConditionsToEmail($offerId: String!) {
      sendTermsAndConditionsToEmail(id: $offerId)
    }
    `);